import SearchGrid from './SearchGrid.vue'

export default SearchGrid
